import type { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { HttpResponse } from '@angular/common/http';
import { inject, Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import type { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { IS_SERVER_TOKEN } from '@app/shared/utils';

interface RequestDetails {
  url: string;
  requestTime: Date;
  responseTime: Date | undefined;
}

// Для отлова зависшых запросов при рендере статики
@Injectable()
export class DebuggingInterceptor implements HttpInterceptor {
  protected readonly ngZone = inject(NgZone);
  readonly #isServer = inject<boolean>(IS_SERVER_TOKEN);
  readonly #router = inject(Router);
  private requests: RequestDetails[] = [];

  constructor() {
    if (this.#isServer) {
      this.printTasksWithDelay();
    }
  }

  printTasksWithDelay(): void {
    const waitSeconds = 3000;

    // eslint-disable-next-line no-console
    console.log(`⏳ Wait ${waitSeconds}ms to dump pending tasks `);
    this.ngZone.runOutsideAngular(() => {
      setTimeout(() => {
        this.printTasks();
      }, waitSeconds);
    });
  }

  printTasks(): void {
    // eslint-disable-next-line no-console
    console.log(`👀 ${this.#router.url}`);
    // console.log(`👀 ${this.router.url}:`, this.requests);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.#isServer) {
      return next.handle(request);
    }
    const requestDetails: {
      url: string;
      requestTime: Date;
      responseTime: Date | undefined;
    } = {
      url: request.url,
      requestTime: new Date(),
      responseTime: undefined,
    };
    this.requests.push(requestDetails);
    return next.handle(request).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            requestDetails.responseTime = new Date();
          }
        },
        (error) => {
          requestDetails.responseTime = new Date();
        },
      ),
    );
  }
}
